<template>
  <span>
    {{ $t(value) }}
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  }
}
</script>
